export default function onlyAdmin({ next }) {
  const middlewareRole = localStorage.getItem('userRole');
  if (middlewareRole && (Number(middlewareRole) === 1)) {
    return next();
  }
  return next('/');
}



// WEBPACK FOOTER //
// ./src/middleware/onlyAdmin.js